import { mapToBooleanOrUndefined, mapToNumberOrUndefined, mapToStringOrUndefined } from '@juvare/widget-ui/Utils';
import { WidgetHandler } from '../../WidgetHandler';
import { callConfigFunction } from './callConfigFunction';
/**
 * Evaluates and applies visibility and update rules on a widget. Updates the hidden state
 * and triggers `onUpdateAny` if specified.
 *
 * @param {WidgetProps<any, any>} props - The widget props containing configuration and state.
 * @returns {boolean} - Whether the widget was updated.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function handleWidgetUpdate(props) {
    const { hidden, event } = props.config;
    if (hidden || (event === null || event === void 0 ? void 0 : event.onUpdateAny)) {
        let update = false;
        const handler = new WidgetHandler(props);
        if (hidden === true) {
            update = setHidden(props, handler, true);
        }
        else if (hidden) {
            if (hidden.custom) {
                let hiddenCustomResult = callConfigFunction(hidden.custom, 'custom conditional visibility', 'handler', handler);
                if (typeof hiddenCustomResult !== 'boolean') {
                    console.error('Custom conditional visibility function must return boolean, true if component should be hidden, false if component should be visible', hiddenCustomResult);
                    hiddenCustomResult = !!hiddenCustomResult;
                }
                update = setHidden(props, handler, hiddenCustomResult);
            }
            else if (hidden.when != null) {
                const whenHandler = handler.select(hidden.when);
                if (whenHandler) {
                    const { dataIn, dataNotIn } = hidden;
                    if (hidden.dataEq != null) {
                        update = setHidden(props, handler, whenHandler.getData(mapperByType(hidden.dataEq)) === hidden.dataEq);
                    }
                    else if (hidden.dataNotEq != null) {
                        update = setHidden(props, handler, whenHandler.getData(mapperByType(hidden.dataNotEq)) !== hidden.dataNotEq);
                    }
                    else if (dataIn != null) {
                        const data = whenHandler.getData(mapperByType(dataIn[0]));
                        const result = dataIn.includes(data);
                        update = setHidden(props, handler, result);
                    }
                    else if (dataNotIn != null) {
                        const data = whenHandler.getData(mapperByType(dataNotIn[0]));
                        const result = !dataNotIn.includes(data);
                        update = setHidden(props, handler, result);
                    }
                }
            }
        }
        if (event === null || event === void 0 ? void 0 : event.onUpdateAny) {
            event.onUpdateAny(handler);
        }
        return update || !!handler.status.update;
    }
    return false;
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function setHidden(props, handler, hidden) {
    if (props.hidden !== hidden) {
        props.hidden = hidden;
        if (hidden && props.config.clearDataOnHide) {
            handler.setData(undefined);
        }
        props.update();
        return true;
    }
    else {
        return false;
    }
}
function mapperByType(data) {
    switch (typeof data) {
        case 'boolean':
            return mapToBooleanOrUndefined;
        case 'number':
            return mapToNumberOrUndefined;
        case 'string':
            return mapToStringOrUndefined;
    }
}
